(function () {
  function initMegaMenuOnce(root = document) {
    root.querySelectorAll('.mega-menu-wrapper').forEach(menu => {
      // avoid double-init
      if (menu.dataset._megaInit === "true") return;
      menu.dataset._megaInit = "true";

      const tabs = Array.from(menu.querySelectorAll('.mega-menu__tab'));
      const panels = Array.from(menu.querySelectorAll('.mega-menu__panel'));

      // Defensive: ensure each tab has a data-target and matching panel id
      tabs.forEach((tab, idx) => {
        if (!tab.dataset.target) {
          const fallback = `panel-fallback-${Math.random().toString(36).slice(2,8)}-${idx}`;
          tab.dataset.target = fallback;
          if (panels[idx] && !panels[idx].id) panels[idx].id = fallback;
        }
      });

      function activateTab(tab) {
        if (!tab) return;
        const targetId = tab.dataset.target;
        const panel = menu.querySelector('#' + CSS.escape(targetId));

        // clear active states inside this menu only
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(p => {
          p.classList.remove('active');
          p.setAttribute('aria-hidden', 'true');
        });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        if (panel) {
          panel.classList.add('active');
          panel.setAttribute('aria-hidden', 'false');
        }
      }

      // event delegation: clicks anywhere in a tab (including the image) will be handled
      menu.addEventListener('click', function (e) {
        const clickedTab = e.target.closest('.mega-menu__tab');
        if (!clickedTab || !menu.contains(clickedTab)) return;
        e.preventDefault();
        e.stopPropagation();
        activateTab(clickedTab);
      }, true); // capture phase to beat overlay issues

      // keyboard support
      tabs.forEach(t => {
        t.setAttribute('role', 'tab');
        t.setAttribute('tabindex', '0');
        t.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            activateTab(t);
          }
          // arrow navigation
          if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') {
            ev.preventDefault();
            const next = tabs[(tabs.indexOf(t) + 1) % tabs.length];
            next && next.focus();
          }
          if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') {
            ev.preventDefault();
            const prev = tabs[(tabs.indexOf(t) - 1 + tabs.length) % tabs.length];
            prev && prev.focus();
          }
        });
      });

      // Activate default (first) tab if nothing active
      const initiallyActive = menu.querySelector('.mega-menu__tab.active') || tabs[0];
      if (initiallyActive) activateTab(initiallyActive);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMegaMenuOnce(document));
  } else {
    initMegaMenuOnce(document);
  }

  // Watch for DOM changes (Shopify section re-renders); re-init newly added nodes
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('.mega-menu-wrapper') || node.querySelector('.mega-menu-wrapper')) {
          initMegaMenuOnce(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();